<template>
    <a
        :href="href"
        class="cta-button"
        target="_blank"
        :class="{ left: position === 'left', right: position === 'right' }"
    >
        <slot />
    </a>
</template>
<script lang="ts">
export default {
    name: "CTAButton",
    props: {
        position: {
            type: String,
            default: "left",
            enum: ["left", "right"]
        },
        href: String
    }
};
</script>
<style scoped>
.cta-button {
    transition-timing-function: cubic-bezier(0, 1.87, 0.75, 1.64);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    width: 100%;
    max-width: 70px;
    height: 50px;
    box-shadow: 0px 3px 5px 0px rgb(50 50 50 / 50%);
    margin-bottom: 15px;
    text-decoration: none;
}

.cta-button.left {
    border-top-left-radius: 40% 50%;
    border-bottom-left-radius: 40% 50%;
    color: var(--buttonTextColor);
    background: var(--secondary);
}

.cta-button.right {
    border-top-right-radius: 40% 50%;
    border-bottom-right-radius: 40% 50%;
    color: var(--secondary);
    background: var(--white);
}
</style>
